import Vue from 'vue'
import Axios from 'axios'
import authConst from './store/modules/auth/authConst'
import store from './store'
import cookie from 'store/modules/auth/cookie'
import api from 'store/modules/auth/api'

Vue.prototype.$http = Axios

Axios.defaults.baseURL = process.env.APP_API
Axios.interceptors.request.use(async config => {
  let token = await api.getToken() || store.state.auth.token
  const collaborationCentralBWToken = cookie.get(authConst.tokenCentralBWName)
  token = collaborationCentralBWToken || token
  if (token) {
    config.headers.setAuthorization('Bearer ' + token)
  }
  config.headers.setContentType('application/json')
  return config
}, error => {
  return Promise.reject(error)
})

Axios.interceptors.response.use(response => {
  return response
}, async error => {
  const { response, message } = error

  if (message.includes('timeout')) {
    return Promise.reject(error)
  }
  if (typeof response === 'undefined') {
    await store.dispatch('notification/SHOW_TRANSLATED_NOTIFICATION', ['errorMessages.internalServerError', 'info'])
    return Promise.reject(new Error('Internal server error.'))
  }

  if (requestErrorInvalidToken(response, store)) {
    await store.dispatch('auth/LOGOUT_USER')
    store.dispatch('notification/SHOW_TRANSLATED_NOTIFICATION', ['errorMessages.expiredToken', 'info'])
  }

  if (store.state.auth.currentProduct !== null && (response.data.error === 'HOTMART_0002' || response.data.error === 'PRODUCT_0001')) {
    await store.dispatch('auth/PRODUCT_ACCESS_DENIED')
  }

  return Promise.reject(error)
})

const requestErrorInvalidToken = (response, store) => {
  const unauthorized = response.status === 401
  const storeHasToken = (store.state.auth.token !== null && response.status === 400 && response.data.error === 'invalid_token')
  const securityExpiredToken = (
    response.data && (response.data.error === 'invalid_token' ||
      (response.data.error_description && response.data.error_description.toLowerCase().indexOf('token has expired') !== -1))
  )

  return unauthorized || storeHasToken || securityExpiredToken
}
